import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';

import { AuthModule } from '®shared/auth';
import { RedirectionModule } from '®shared/redirection';
import { UserModule } from '®shared/user';

import { CurrentUserGuard } from './current-user-guard.service';
import { CurrentUserService } from './current-user.service';

@NgModule({
  imports: [CommonModule, AuthModule, RedirectionModule, UserModule],
})
export class CurrentUserModule {
  /**
   * The CurrentUser services should be true, shared singletons.
   *
   * @see {@link https://angular-2-training-book.rangle.io/handout/modules/shared-di-tree.html}
   * @return {ModuleWithProviders<CurrentUserModule>} Auth service singletons
   */
  static forRoot(): ModuleWithProviders<CurrentUserModule> {
    return {
      ngModule: CurrentUserModule,
      providers: [CurrentUserGuard, CurrentUserService],
    };
  }
}
